import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEventCallback } from '@cian/react-utils';
import { DistanceRange } from '../../../components/filters/extra_filters/components/DistanceRange';
import { selectDistance, selectRegionId } from '../../../selectors/filters';
import { changeCommuteDistance, changeCommuteDistanceType } from '../../../store/filters/actions';
import { ECommuteDistanceType } from '../../../types/filters/distanceType';
import { TTypedThunkDispatch } from '../../../types/store';
import { generateDistanceTypes } from './utils';

export const DistanceContainer = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();

  const { commuteKmFrom, commuteKmTo, commuteDistanceType } = useSelector(selectDistance);
  const regionId = useSelector(selectRegionId);

  const distanceTypes = React.useMemo(() => generateDistanceTypes(regionId), [regionId]);

  // Выбираем шоссе, если явно не указан тип и указано хоть одно из расстояний
  const selectedDistanceType = React.useMemo(() => {
    return (commuteKmFrom !== undefined || commuteKmTo !== undefined) && !commuteDistanceType
      ? ECommuteDistanceType.Road
      : commuteDistanceType;
  }, [commuteKmFrom, commuteKmTo, commuteDistanceType]);

  const handleChangeDistanceType = useEventCallback((type: ECommuteDistanceType) => {
    return dispatch(changeCommuteDistanceType(type));
  });

  const handleChangeDistance = useEventCallback((min: number | undefined, max: number | undefined) => {
    return dispatch(changeCommuteDistance({ min, max }));
  });

  return (
    <DistanceRange
      distanceTypes={distanceTypes}
      selectedDistanceType={selectedDistanceType}
      valueMin={commuteKmFrom}
      valueMax={commuteKmTo}
      onChangeDistanceType={handleChangeDistanceType}
      onChangeDistance={handleChangeDistance}
    />
  );
};
